export const RIDANGO_PASSWORD_RECOVERY_STEPS = [
    'PASSWORD_RECOVERY_PROGRESS_YOUR_DETAILS',
    'PASSWORD_RECOVERY_PROGRESS_CONFIRMATION_EMAIL',
    'PASSWORD_RECOVERY_PROGRESS_NEW_PASSWORD'
];

export const FEATURE_FLAGS = {
    BookARide: ['IM-537-DRT-Links', 'LAP-401-DRT-Links'],
    FrontendRecaptcha: ['FRONTEND_RECAPTCHA']
};
